import { useContext } from "react";
import {
  WarehouseArticleSettingsDeleteContextValue,
  WarehouseArticleSettingsHandlerContextValue,
} from "./types";
import {
  WarehouseArticleSettingsDeleteContext,
  WarehouseArticleSettingsHandlerContext,
} from "./contexts";

/* ===========================================================================
 * HOOK: useWarehouseArticleSettingsHandlerContext
 * ===========================================================================
 */

/**
 * @function useWarehouseArticleSettingsHandlerContext
 *
 * Provides access to the WarehouseArticleSettingsHandlerContext.
 * Ensures that the component using this hook is wrapped inside
 * a WarehouseArticleSettingsHandlerProvider.
 *
 * @returns {WarehouseArticleSettingsHandlerContextValue} The current handler context value.
 * @throws {Error} If called outside of a WarehouseArticleSettingsHandlerProvider.
 */
export const useWarehouseArticleSettingsHandlerContext =
  (): WarehouseArticleSettingsHandlerContextValue => {
    const context = useContext(WarehouseArticleSettingsHandlerContext);
    if (!context) {
      throw new Error(
        "useWarehouseArticleSettingsHandlerContext must be used within a WarehouseArticleSettingsHandlerProvider",
      );
    }
    return context;
  };

/* ===========================================================================
 * HOOK: useWarehouseArticleSettingsDeleteContext
 * ===========================================================================
 */

/**
 * @function useWarehouseArticleSettingsDeleteContext
 *
 * Provides access to the WarehouseArticleSettingsDeleteContext.
 * Ensures that the component using this hook is wrapped inside
 * a WarehouseArticleSettingsDeleteProvider.
 *
 * @returns {WarehouseArticleSettingsDeleteContextValue} The current delete context value.
 * @throws {Error} If called outside of a WarehouseArticleSettingsDeleteProvider.
 */
export const useWarehouseArticleSettingsDeleteContext =
  (): WarehouseArticleSettingsDeleteContextValue => {
    const context = useContext(WarehouseArticleSettingsDeleteContext);
    if (!context) {
      throw new Error(
        "useWarehouseArticleSettingsDeleteContext must be used within a WarehouseArticleSettingsDeleteProvider",
      );
    }
    return context;
  };
